import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CacheableURLsInjectionToken } from './interfaces/cacheable-urls.interface';
import { OfflineStrategy, OfflineStrategyInjectionToken } from './interfaces/offline-strategy.interface';
import { defaultOnlineDetector, OnlineDetectorInjectionToken } from './interfaces/online-detector.interface';
import { IndexeddbOfflineStrategyService } from './service/offline-strategies/indexeddb-offline-strategy.service';
import { OfflineService } from './service/offline.service';
import { HydrationEffects } from './store/effects/hydration.effect';
import { RefreshRequestQueueEffects } from './store/effects/refresh-request-queue.effect';
import { RequestQueueEffects } from './store/effects/request-queue.effect';
import { cacheInfoReducer } from './store/reducers/cache-info.reducer';
import { cacheReducer } from './store/reducers/cache.reducer';
import { hydrationMetaReducer } from './store/reducers/hydrate.reducer';
import { refreshRequestQueueReducer } from './store/reducers/refresh-request-queue.reducer';
import { requestQueueReducer } from './store/reducers/request-queue.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            'paceOffline',
            {
                cache: cacheReducer,
                cacheInfo: cacheInfoReducer,
                requestQueue: requestQueueReducer,
                refreshRequestQueue: refreshRequestQueueReducer,
            },
            {
                metaReducers: [hydrationMetaReducer],
            },
        ),
        EffectsModule.forFeature([HydrationEffects, RequestQueueEffects, RefreshRequestQueueEffects]),
    ],
})
export class PaceOfflineModule {
    public static forRoot(
        cacheableURLs: string[],
        offlineStrategy?: Type<OfflineStrategy>,
        onlineObservable?: Observable<boolean>,
    ): ModuleWithProviders<PaceOfflineModule> {
        return {
            ngModule: PaceOfflineModule,
            providers: [
                OfflineService,
                IndexeddbOfflineStrategyService,
                {
                    provide: OfflineStrategyInjectionToken,
                    useClass: offlineStrategy ?? IndexeddbOfflineStrategyService,
                },
                {
                    provide: CacheableURLsInjectionToken,
                    useValue: cacheableURLs,
                },
                {
                    provide: OnlineDetectorInjectionToken,
                    useValue: onlineObservable ?? defaultOnlineDetector,
                },
            ],
        };
    }
}
